<section outline>
  <h2>Billing</h2>

  <div class="mb-3">
    <label>Currency:</label>
    <span>{{ currency.iso3 }} - {{ currency.name }}</span>
  </div>

  <div class="mb-3">
    <label>Entity:</label>
    <span>{{ subsidiary.name }}</span>
  </div>

  <div class="mb-3">
    <label>Address:</label>
    <address-block [address]="address"></address-block>
  </div>
</section>
